import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SipPitchCardComponent } from './sip-pitch-card.component';



@NgModule({
  declarations: [
    SipPitchCardComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [SipPitchCardComponent]
})
export class SipPitchCardModule { }
